import styled from "@emotion/styled"
import { ScrollArea } from "radix-ui"
import { ReactNode, forwardRef } from "react"

const StyledScrollArea = styled(ScrollArea.Root)`
  height: calc(100% - 80px);
  width: 100%;
  overflow: hidden;
`

const StyledScrollViewport = styled(ScrollArea.Viewport)`
  width: 100%;
  height: 100%;
  overflow: auto;
`

const StyledScrollbar = styled(ScrollArea.Scrollbar)`
  display: flex;
  user-select: none;
  touch-action: none;

  padding: 30px 2px 2px 2px;
  position: relative;
  z-index: 10;
  background: transparent;
  box-sizing: border-box;

  &[data-orientation="vertical"] {
    width: 12px;
  }
`

const StyledThumb = styled(ScrollArea.Thumb)`
  flex: 1;

  background: rgba(0, 0, 0, 0.25);
  position: relative;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background: rgba(0, 0, 0, 0.35);
  }
`

interface SupportScrollAreaProps {
  children: ReactNode
}

const SupportScrollArea = forwardRef<HTMLDivElement, SupportScrollAreaProps>(
  function SupportScrollArea({ children }, ref) {
    return (
      <StyledScrollArea type="always">
        <StyledScrollViewport ref={ref}>{children}</StyledScrollViewport>
        <StyledScrollbar orientation={"vertical"}>
          <StyledThumb />
        </StyledScrollbar>
      </StyledScrollArea>
    )
  }
)

export default SupportScrollArea
